import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 relative" data-id="element-172">
      <div className="max-w-4xl mx-auto" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-174">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-relaxed" data-id="element-175">
            Si hoy sentís que estás en una cinta de correr que no se detiene,
            pero no avanzás un solo metro,{' '}
            <span className="text-red-400" data-id="element-176">no es tu culpa. Es el sistema.</span>
          </h2>
        </motion.div>

        <div className="space-y-8 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-177">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-178">
            Estás vendiendo tu tiempo en una moneda que se derrite mientras
            dormís. Cada vez que el supermercado remarca sus precios, tu
            esfuerzo vale menos. Es hora de dejar de jugar con las reglas de una
            economía local rota y empezar a jugar con las del mercado global.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-[#111827] border border-gray-800 p-8 rounded-2xl relative overflow-hidden" data-id="element-179">
            <div className="absolute top-0 left-0 w-1 h-full bg-red-500" data-id="element-180" />
            <AlertCircle className="w-8 h-8 text-red-500 mb-4 opacity-80" data-id="element-181" />
            <p className="mb-6" data-id="element-182">
              Trabajás 8, 10 o 12 horas al día para que, al final del mes, el
              alquiler y las expensas se lleven el 70% de tu sueldo. Mirás tu
              recibo de haberes en pesos y sentís ese nudo en el estómago porque
              sabés que, por más que te esfuerces, la inflación siempre gana la
              carrera.
            </p>
            <p data-id="element-183">
              Intentaste cursos de programación que duran años, buscaste "dinero
              fácil" en encuestas que pagan centavos o probaste con el trading y
              terminaste perdiendo lo poco que tenías. El problema no es tu
              falta de voluntad, es que nadie te enseñó el Arbitraje de
              Micro-tareas.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}